export const GET_HOMEPAGE_REQUEST = "GET_HOMEPAGE_REQUEST";
export const GET_HOMEPAGE_SUCCESS = "GET_HOMEPAGE_SUCCESS";
export const GET_HOMEPAGE_FAILURE = "GET_HOMEPAGE_FAILURE";